import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import { UserSubHeaderBooks } from 'client/bookmate/blocks/user-sub-header-books'
import {
  buildUser,
  getRecentItems,
} from 'client/bookmate/reducers/user-reducer'
import { State } from 'shared/types/redux'
import { CurrentUserState } from 'client/shared/types/current-user'
import { RecentItem } from 'client/shared/types/user'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  user?: CurrentUserState
  query?: QueryParams
  recentItems: RecentItem[]
}

class UserSubHeaderBooksBox extends Component<Props> {
  render() {
    const { user, recentItems, query } = this.props
    return (
      <UserSubHeaderBooks user={user} recentItems={recentItems} query={query} />
    )
  }
}

const connectWrapper = connect((state: State) => ({
  query: state.app.storedQuery,
  user: buildUser(state, state.user.login),
  currentUser: state.currentUser,
  recentItems: getRecentItems(state, state.user.recentItems),
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(UserSubHeaderBooksBox)
